import { inject } from 'inversify';

import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { ISettingsAzerPost } from '../interfaces';
import { SettingsMapper } from '../mappers';

export type IGetAzerPostSettingsByIdRepoResponse = IRepoResponse<200, ISettingsAzerPost> | IRepoResponse<400 | 500, string>;

export type IGetAzerPostSettingsByIdRepo = IRepo<[number | string], IGetAzerPostSettingsByIdRepoResponse>;

export const GetAzerPostSettingsByIdRepoType = Symbol.for('GetAzerPostSettingsByIdRepo');

@bind(GetAzerPostSettingsByIdRepoType)
export class GetAzerPostSettingsByIdRepo implements IGetAzerPostSettingsByIdRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute() {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/settings/data', { group_id: 'azerpost' }) });

      if (result.status === 200) {
        const data: any = SettingsMapper.azerpostToDomain(result.data.data);

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
